import { AbstractControl, ValidatorFn } from '@angular/forms';

export function selectRequiredValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    return control.value === -1 ? { required: true } : null;
  };
}